
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
// import { useLocation } from 'react-router-dom';  // Import useLocation hook
import { useSelector } from 'react-redux';

const NonAuthLayout = (props) => {
  const { layoutMode } = useSelector((state) => ({
    layoutMode: state.Layout.layoutMode,
  }));

  // const location = useLocation(); // Use useLocation hook to get the location

  useEffect(() => {
    if (layoutMode === "dark") {
      document.body.setAttribute("data-bs-theme", "dark");
    } else {
      document.body.setAttribute("data-bs-theme", "light");
    }
  }, [layoutMode]);

  return (
    <React.Fragment>{props.children}</React.Fragment>
  );
};

NonAuthLayout.propTypes = {
  children: PropTypes.any,
};

export default NonAuthLayout;
